/**
 * Dialog_error snippet
 * 
 * @class Snippet_Dialog_error
 * @extends Snippet_Dialog
 */

Snippet_Dialog_error = (function(Snippet) {

	var Snippet_Dialog_error = function() {
		this.construct.apply(this, arguments);
	};

	$.extend(true, Snippet_Dialog_error.prototype, Snippet_Dialog.prototype, {
		buttons: [{cls: '', action: 'go-back', label: 'ok'}],
		title: '',
		message: '',


		/**
		 * @inheritdoc Dialog#setCallBack
		 */
		setCallback: function(callback) {
			this.callback = callback;
		},
		
		setButtons: function(buttons) {
			this.buttons = buttons;
		},

		/**
		 * @inheritdoc Dialog#renderHeader
		 */
		renderHeader: function(){
			//this.$el.append('<div class="title">'+this.title+'</div>');
			this.$el.append('<div class="title"><div class="logo"></div></div>');
		},

		/**
		 * @inheritdoc Dialog#renderContent
		 */
		renderContent: function(){
			this.$el.append('<div class="content">'+this.message+'</div>');
		},
		
		/**
		 * @inheritdoc Dialog#renderButtons
		 */
		renderButtons: function(){
			$buttons = $('<ul class="buttons" />');
			var button;
			for(var i = 0; i < this.buttons.length; i++){
				button = this.buttons[i];
				$buttons.append('<li class="focusable button '+ button.cls + '" style="background-color: grey;" data-action="' + button.action + '" data-tr="' + __(button.label) + '">' + button.label + '</li>');
			}
			
			this.$el.append($buttons);
		},
		onEnter: function($el, event) {			
			var action = $el.attr('data-action');
			if(action === 'go-back'){
				this.onClose();
			} else if (action === 'callback' && typeof this.callback === 'function') {
				this.destroy();
				this.callback();
				this.callback = null;
			}
			return false;
		},
		onClose: function() {
			console.log('error dialog calback');
			if(typeof this.callback === 'function') {
				this.callback();
			}
			this.destroy();
			this.callback = null;
			return false;
		}
	});

	return Snippet_Dialog_error;

})(Snippet);


//////////////////
// WEBPACK FOOTER
// ./js/snippet/dialog_error.js
// module id = 68
// module chunks = 0